<template>
  <div>
    <div
      class="modal-header"
      :aria-label="$t('choose.a.desk')"
    >
      <h2>{{ $t('choose.a.desk') }}</h2>
    </div>
    <div class="modal-content">
      <form
        id="form-choose-table"
      >
        <p>{{ $t('choose.desk.for.attendance') }}</p>
        <div class="input-group">
          <input
            v-model.number="desk"
            class="input"
            type="number"
            step="1"
            min="1"
            max="30"
            placeholder="1"
          >
        </div>
        <div class="form-actions">
          <button
            type="button"
            class="btn-secondary"
            @click="close()"
          >
            {{ $t('cancel') }}
          </button>
          <button
            id="confirm-choose-table"
            :disabled="desk === 0 || desk === ''"
            type="button"
            class="btn-primary btn-active main-action"
            @click="chooseDesk()"
          >
            {{ $t('choose.desk', { desk }, desk) }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import DeskAPI from '@/api/desk'
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      open: false,
      desk: 0
    }
  },
  computed: {
    ...mapState(['loggedUser'])
  },
  async mounted () {
    setTimeout(() => {
      this.open = true
    }, 100)
  },
  methods: {
    ...mapActions(['fetchProfile']),
    async close () {
      this.$emit('input', false)
    },
    async chooseDesk () {
      if (this.desk !== 0) {
        await DeskAPI.choose({ desk: this.desk })
        this.fetchProfile()
        this.close()
      }
    }
  }
}
</script>
